import Dropdown from "../Dropdown";
import { projectMenus } from "../ProjectMenus";

export default function SafetyMenu(props) {
  return (
    <Dropdown
      menuKey="safety"
      menu={projectMenus.safety}
      {...props}
    />
  );
}
